<template>
  <v-dialog v-model="show" hide-overlay persistent width="300">
    <v-card color="#424242" dark>
      <v-card-text>
        <v-progress-circular indeterminate color="white"></v-progress-circular>
        {{ message }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    message: {
      type: String,
      default: "Cargando...",
      required: false,
    },
  },
};
</script>
